
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as ServiceService from '@/services/merchantSpace/ServiceService';
import SvgPictoCopy from '@/components/Svg/SvgPictoCopy.vue';

@Component({
  components: { SvgPictoCopy },
})
export default class DashboardProfileCard extends Vue {
  @Prop({ type: String, required: true })
  readonly referralCode!: string;

  @Prop({ type: Array, required: true })
  readonly userServices!: [];

  snackbar: boolean = false;

  services: any = null;

  points: number = 0;

  limit: number = 0;

  frequency: string = '';

  displayCopy: boolean = false;

  isReferral: boolean = false;

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }

  async created() {
    await this.getActionsData();
  }

  async getActionsData() {
    const defaultRankSort = 0;
    const referCategory = 3;


    const serviceIds: number[] = this.userServices.map(({ serviceId }) => serviceId);
    this.services = await ServiceService.getPlatformServices();

    let affiliateServices = this.services.filter(({ actionCreditList, serviceId }) => actionCreditList && serviceIds.includes(serviceId));

    if (!affiliateServices.length) return;

    if (affiliateServices.length > 1) {
      affiliateServices = affiliateServices.filter(({ rank }) => rank === defaultRankSort);
    }

    const referAction = affiliateServices[0].actionCreditList.find(({ isRevoked, actionCategoryId }) => !isRevoked && actionCategoryId === referCategory);

    let textFrequency = '';
    switch (referAction.frequencyId) {
      case 1:
        textFrequency = '';
        break;
      case 2:
        textFrequency = ' par jour';
        break;
      case 3:
        textFrequency = ' par semaine';
        break;
      case 4:
        textFrequency = ' par mois';
        break;
      case 5:
        textFrequency = ' par an';
        break;
      default:
        textFrequency = '';
    }

    if (referAction) {
      this.points = referAction.value;
      this.limit = referAction.limit;
      this.frequency = textFrequency;
    }
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.referralCode);
    this.displayCopy = true;
    setTimeout(() => {
      this.displayCopy = false;
    }, 1500);
  }
}
